const DEFAULT_LOGIN_PATH = '/login';

export function sanitizeNextPath(nextPath) {
  if (!nextPath || typeof nextPath !== 'string') {
    return '';
  }

  if (!nextPath.startsWith('/') || nextPath.startsWith('//')) {
    return '';
  }

  return nextPath;
}

export function buildLoginRedirectPath(pathname, search = '', reason = 'session-ended') {
  const normalizedPath = sanitizeNextPath(`${pathname || '/'}`) || '/';

  if (normalizedPath.startsWith(DEFAULT_LOGIN_PATH)) {
    return DEFAULT_LOGIN_PATH;
  }

  const params = new URLSearchParams();
  const normalizedSearch = typeof search === 'string' ? search : '';

  if (reason) {
    params.set('reason', reason);
  }

  const nextPath = sanitizeNextPath(`${normalizedPath}${normalizedSearch}`);
  if (nextPath) {
    params.set('next', nextPath);
  }

  const query = params.toString();
  return query ? `${DEFAULT_LOGIN_PATH}?${query}` : DEFAULT_LOGIN_PATH;
}
